import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { staggeredBaseQuery } from "./staggeredBaseQuery";
import { TrainingDocument } from "../../common/TrainingDocument";
import { ActionByType } from "../../common/ProfileDocument";


export const trainingDocumentApi = createApi({
    reducerPath: "trainingDocumentApi",
    tagTypes: ["TrainingDocument"],
    baseQuery: staggeredBaseQuery(""),
    endpoints: (builder) => ({
        getProfileTrainingDocuments: builder.query<TrainingDocument[], number>({
            query: (profileId) => {
                return {
                    method: "GET",
                    url: `trainingDocuments?profileId=${profileId}`,
                };
            },
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({
                            type: "TrainingDocument" as const,
                            id,
                        })),
                        { type: "TrainingDocument", id: "LIST" },
                    ]
                    : [{ type: "TrainingDocument", id: "LIST" }],
        }),
        getTrainingDocument: builder.query<TrainingDocument, String>({
            query: (trainingDocumentId) => {
                return {
                    method: "GET",
                    url: `trainingDocuments/${trainingDocumentId}`,
                }
            }
        }),
        downloadTrainingDocument: builder.mutation<Blob, { fileKey: String }>({
            query: ({ fileKey }) => {
                fileKey = fileKey.replaceAll('[', '%5B').replaceAll(']', '%5D');
                return {
                    method: 'GET',
                    url: `${fileKey.charAt(0) === '/' ? fileKey : `/${fileKey}`}`,
                    responseHandler: (response) => response.blob()
                };
            },
        }),
        uploadTrainingDocument: builder.mutation<TrainingDocument, FormData>({
            query: (data) => {
                return {
                    method: "POST",
                    url: "trainingDocuments/",
                    body: data,
                };
            },
            invalidatesTags: [{ type: "TrainingDocument", id: "LIST" }],
        }),
        updateTrainingDocument: builder.mutation<
            TrainingDocument,
            { trainingDocumentId: String; trainingDocument: Partial<TrainingDocument> }
        >({
            query: ({ trainingDocumentId, trainingDocument }) => {
                return {
                    method: "PUT",
                    url: `trainingDocuments/${trainingDocumentId}`,
                    body: trainingDocument,
                };
            },
            invalidatesTags: [{ type: "TrainingDocument", id: "LIST" }],
        }),
        deleteTrainingDocument: builder.mutation<void, { trainingDocumentId: String, actionByType: ActionByType }>({
            query: ({ trainingDocumentId, actionByType }) => {
                return {
                    method: "DELETE",
                    url: `trainingDocuments?id=${trainingDocumentId}&actionByType=${actionByType}`,
                };
            },
            invalidatesTags: (result, error, trainingDocumentId) => [
                { type: "TrainingDocument", trainingDocumentId },
            ],
        }),
    })
});

export const {
    useGetProfileTrainingDocumentsQuery,
    useGetTrainingDocumentQuery,
    useDownloadTrainingDocumentMutation,
    useUploadTrainingDocumentMutation,
    useUpdateTrainingDocumentMutation,
    useDeleteTrainingDocumentMutation,
} = trainingDocumentApi;